<template>
  <input
      @input="$emit('input', $event.target.value || null)"
      :value="value"
      :type="type"
      class="input"
      :class="{ 'input--design-new': design === 'new', 'input--error': error }"
  />
</template>

<script>
export default {
  name: 'AppInput',
  props: {
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    },
    value: [String, Number, Date],
    type: {
      default: 'text',
      validator: value => {
        return ['text', 'email', 'password', 'url', 'number', 'datetime-local', 'search', 'time'].includes(value)
      }
    },
    error: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="sass">
.input
  width: 100%
  padding: 10px 12px 11px
  border: 1px solid $color-border
  border-radius: 6px
  color: $color-text-base
  background-color: #fff
  font-family: $font-family-base
  font-size: 13px
  font-weight: 400
  line-height: 15px
  transition: border-color 0.3s, color 0.3s, background-color 0.3s

  &::placeholder
    color: #818181

  &:focus
    border-color: #aaa

  &[readonly]
    pointer-events: none
    border-color: #ff9416

  &[disabled]
    opacity: 0.7

  &[type="search"]
    padding-right: 30px
    background-image: url("~@/assets/img/search-input.svg")
    background-repeat: no-repeat
    background-position: right 10px center
    background-size: 14px

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0

  &[type=number]
    -moz-appearance: textfield

  &[type=time]
    padding: 8px 12px

.input--error
  border-color: $color-error

.input--center
  text-align: center

.input--300
  max-width: 300px

.input--290
  max-width: 290px

.input--250
  max-width: 250px

.input--200
  max-width: 200px

.input--150
  max-width: 150px

.input--100
  max-width: 100px

.input--65
  max-width: 65px

.input--45
  max-width: 45px

.input--min-200
  min-width: 200px

.input--min-300
  min-width: 300px

.family.input
  color: #000
  font-family: 'CoreSansCR', sans-serif
  font-size: 14px
  font-weight: 400

  &::placeholder
    color: #707070

.input.input--design-new
  box-sizing: border-box
  min-height: $ui-control-height
  padding: 9px $ui-space-12
  border-color: $ui-line-strong
  border-radius: $ui-control-radius
  color: $ui-ink
  font-family: $ui-font-body
  font-size: $ui-font-size-body
  line-height: 20px
  transition: border-color .15s ease

  &::placeholder
    color: $ui-subtle
    font-family: $ui-font-body

  &:focus
    border-color: var(--ui-accent, #{$ui-blue})
    outline: 0

  &[readonly]
    border-color: $ui-line-strong
    background-color: $ui-surface-soft
    color: $ui-muted

  &[disabled]
    background-color: $ui-surface-soft
    color: $ui-subtle
    cursor: not-allowed
    opacity: 1

  &.input--error
    border-color: $ui-red
</style>
